const AddBlankCraftedStructureForPagesWithoutData = (pages, data) => {

    const datacopy = Array.isArray(data) ? [...data] : data === undefined || data === null ? [] : {...data};
//   const datacopy = Array.isArray(data) ? data : [];

    let pageCount = 1;
    for (const page of pages) {
        if (page.Crafted) {
            data.Crafted = data.Crafted === undefined ? [] : data.Crafted;
            const craftedItem = data.Crafted.findIndex((item) => item.Name === page.Name);
            if (craftedItem === -1) {
                const newContents = pageCount === 1 ? datacopy : [];
                const newItem = { Name: page.Name, Contents: newContents};
                data.Crafted.push(newItem);
            }
        }
        pageCount++;
    };
}

export { AddBlankCraftedStructureForPagesWithoutData }